module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-25.d2312041.png";